export default {
	text: 'Tekst',
	select: 'Valik',
	inputValue: 'Sisesta väärtus',
	checkbox: 'Lüliti',
	calendar: 'Kalender',
	user: 'Kasutaja',
	tables: {
		assets: 'Varad',
		sub_assets: 'Alamvarad',
		data_assets: 'Infovarad',
		users: 'Kasutajad',
		instances: 'Asutused',
		standard_methods: 'Meetmed',
		standard_method_meta_data: 'Meetme seosed',
		business_processes: 'Äriprotsessid',
	},
}
